import { Trans } from '@lingui/macro';
import {
  createBrowserRouter,
  Outlet,
  ScrollRestoration,
} from 'react-router-dom';

import { AuthGuard } from '../domains/auth/auth-guard/auth-guard';
import { CabinetIndexPage } from '../domains/cabinet/pages/cabinet.index.page';
import { UserOrdersCacheProvider } from '../domains/cabinet/pages/cabinet.root.page';
import { ReviewsPage } from '../domains/feedback/reviews.page';
import { PushNotifyPage } from '../domains/push-notify/push-notify.page';
import { BuyTicketsPage } from '../pages/buy-tickets/buy-tickets';
import { CabinetRootPage } from '../pages/cabinet-root/cabinet-root.page';
import { LogoutPage } from '../pages/logout/logout.page';
import { MainPage } from '../pages/main/main.page';
import { MyOrdersPage } from '../pages/my-orders/my-orders.page';
import { MyTicketsPage } from '../pages/my-tickets/my-tickets.page';
import { OrderDetailsPage } from '../pages/order-details/order-details.page';
import { OrderStatusPage } from '../pages/order-status/order-status.page';
import { PushNotifyRateTripPage } from '../pages/push-notify-rate-trip/push-notify-rate-trip.page';
import { ResetPasswordPage } from '../pages/reset-password/reset-password.page';
import { SearchPage } from '../pages/search/search.page';
import { SignInPage } from '../pages/sign-in/sign-in.page';
import { SignUpPage } from '../pages/sign-up/sign-up.page';
import { TicketDetailsPage } from '../pages/ticket-details/ticket-details.page';
import {
  routeCabinet,
  routeLogout,
  routeMain,
  routeOrderStatus,
  routeOrderTickets,
  routePushNotifyRate,
  routeResetPassword,
  routeSearch,
  routeSignIn,
  routeSignUp,
} from './routes';

const RouterRoot = () => {
  return (
    <UserOrdersCacheProvider>
      <Outlet />
      <ScrollRestoration />
    </UserOrdersCacheProvider>
  );
};

export const router = createBrowserRouter([
  {
    path: routeMain.path,
    element: <RouterRoot />,
    children: [
      { index: true, element: <MainPage /> },

      {
        path: routeCabinet.path,
        element: (
          <AuthGuard>
            <CabinetRootPage />
          </AuthGuard>
        ),
        children: [
          { index: true, element: <CabinetIndexPage /> },
          {
            path: routeCabinet.ORDERS.path,
            element: <MyOrdersPage />,
          },
          {
            path: routeCabinet.ORDER.path,
            element: <OrderDetailsPage />,
          },
          {
            path: routeCabinet.TICKETS.path,
            element: <MyTicketsPage />,
          },
          {
            path: routeCabinet.TICKET.path,
            element: <TicketDetailsPage />,
          },
          {
            path: routeCabinet.REVIEWS.path,
            element: <ReviewsPage />,
          },
          {
            path: routeCabinet.NOTIFICATIONS_SETTINGS.path,
            element: <PushNotifyPage />,
          },
        ],
      },
      {
        path: routeSearch.path,
        element: <SearchPage />,
      },
      {
        path: routeSignIn.path,
        element: <SignInPage />,
      },
      {
        path: routeResetPassword.path,
        element: <ResetPasswordPage />,
      },
      {
        path: routeSignUp.path,
        element: <SignUpPage />,
      },
      {
        path: routeOrderTickets.path,
        element: (
          <AuthGuard>
            <BuyTicketsPage />
          </AuthGuard>
        ),
      },
      // {
      //   path: routeTickets.path,
      //   element: (
      //     <AuthGuard>
      //       <MyTicketsPage />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: routeTicket.path,
      //   element: (
      //     <AuthGuard>
      //       <TicketDetailsPage />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: routeOrder.path,
      //   element: (
      //     <AuthGuard>
      //       <OrderDetailsPage />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: routeOrders.path,
      //   element: (
      //     <AuthGuard>
      //       <MyOrdersPage />
      //     </AuthGuard>
      //   ),
      // },
      {
        path: routeOrderStatus.path,
        element: (
          <AuthGuard>
            <OrderStatusPage />
          </AuthGuard>
        ),
      },
      {
        path: routeLogout.path,
        element: (
          <AuthGuard>
            <LogoutPage />
          </AuthGuard>
        ),
      },
      {
        path: routePushNotifyRate.path,
        element: <PushNotifyRateTripPage />,
      },
      {
        path: '*',
        element: (
          <div style={{ padding: 20, textAlign: 'center' }}>
            <Trans>Страница не найдена</Trans>
          </div>
        ),
      },
    ],
  },
]);
